<template>
  <assignment></assignment>
</template>

<script>
import Assignment from '@/components/acknowledgment/Assignment.vue'

export default {
  name: 'Access',
  components: { Assignment },
}
</script>

<style lang="scss" scoped></style>
